import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { actions as userActions } from 'builder/modules/user'
import { actions as resumeEditorActions } from 'builder/modules/resumeEditor'
import { BriefResume, actions as panelActions } from 'builder/modules/panel'
import { useUser } from 'builder/hooks/useUser'

export const useOnboardingActions = (resume?: BriefResume) => {
  const user = useUser()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const onFinishClick = () => {
    const path = resume ? `/resumes/${resume.id}/edit` : '/resumes'
    if (resume) {
      dispatch(resumeEditorActions.setIsCustomizeModalOpen(true))
    }
    navigate(path, { replace: true })

    if (user?.uiStates?.welcomeModalSeen) return
    dispatch(panelActions.setUIStatesConfigStatus({ welcome_modal_seen: true }))
    dispatch(userActions.setUIUserState({ welcomeModalSeen: true }))
  }

  return { onFinishClick }
}
